<template>
<div class="search_bar">
  <div id="tooltipSearchBarHome" class="tooltipSearchBar" :style="tooltipStyle" v-if="active && Home == 'true' && goActive">
      <p class="introductionExtend">
        {{ $t("message['ResumeFonctionnalitees_A']") }} <br />
        <ul class="introductionExtend">
            <li>{{ $t("message['ResumeFonctionnalitees_B']") }}</li>
            <li>{{ $t("message['ResumeFonctionnalitees_C']") }}</li>
        </ul>
        {{ $t("message['ResumeFonctionnalitees_E']") }} <br />
      </p>
  </div>

  <form v-on:submit.prevent @mouseleave="active = false" @mouseover="active = true" @click="updateGoActiveE">
    <span class="icon_location"></span>
    <autocomplete class="adresse" :input-attrs="{ autofocus: true , placeholder: $t('message[\'Entrez une adresse, un code postal ou un nom de ville\']') }" :value="$store.state.adresse.filter" :items="results" :get-label="getLabel" :component-item='adresseTemplate'
      :auto-select-one-item="false" @update-items="search" @item-selected="adresseSelected" @item-clicked="adresseClicked" @focus="clickSearchBarGoActiveEOff" @blur="clickSearchBarGoActiveEOn"/>
    <div class="search-btn" @click="go" />
  </form>
</div>
</template>

<script>
import Autocomplete from 'v-autocomplete'
import 'v-autocomplete/dist/v-autocomplete.css'
import axios from 'axios'
import AdresseTemplate from './SearchAdresseTemplate.vue'
import _ from 'lodash'

export default {
  name: 'SearchAdresse',
  components: {
    Autocomplete
  },

  i18n: {
    messages: {
      en: {
        message: {
          'Entrez une adresse, un code postal ou un nom de ville': 'Enter an address, a zip code or a city name'
        }
      },
      fr: {
        message: {
          'Entrez une adresse, un code postal ou un nom de ville': 'Entrez une adresse, un code postal ou un nom de ville'
        }
      }
    }
  },

  props: ['Home', 'goActive'],

  data() {
    return {
      selected: null,
      results: [],
      adresseTemplate: AdresseTemplate,
      active: false
    }
  },
  computed: {
    isVideoPNSEVisible() {
      return this.$store.state.paramUrl.VIDEO_PNSE_VISIBLE ? this.$store.state.paramUrl.VIDEO_PNSE_VISIBLE === 'true' : false
    },
    isPnseActif() {
      return this.$store.state.paramUrl.PNSE_ACTIF ? this.$store.state.paramUrl.PNSE_ACTIF === 'true' : false
    },
    tooltipStyle() {
      let baseTop = 419
      if (this.isPnseActif) {
        baseTop += 26
        if (this.isVideoPNSEVisible) baseTop += 69
      }
      return { top: baseTop + 'px' }
    }
  },
  methods: {
    updateGoActiveE() {
      this.$emit('update-goActive', false)
    },
    clickSearchBarGoActiveEOff() {
      this.$emit('update-goActive-SearchBar-Off', false)
    },
    clickSearchBarGoActiveEOn() {
      this.$emit('update-goActive-SearchBar-On', false)
    },
    getLabel(item) {
      return item && item.properties ? item.properties.label : ''
    },
    search(text) {
      this.updateGoActiveE()
      axios.get('https://data.geopf.fr/geocodage/search/?limit=20&q=' + text)
        .then((response) => {
          const features = response.data.features

          // Affichage des numéros (2 pour la France métropolitaine et 3 pour la France d'outre-mer) du département pour chaque commune.
          if (response.data) {
            _.forEach(features,
              feature => {
                feature.properties.label = (feature.properties.type === 'municipality')
                  ? feature.properties.label + ' (' + feature.properties.citycode.substring(0, ['97', '98'].includes(feature.properties.citycode.substring(0, 2))
                    ? 3
                    : 2) + ')'
                  : feature.properties.label
              })
          }

          // Filtrer les résultats par type 'municipality'
          const municipalityFeatures = features.filter(feature => feature.properties.type === 'municipality')

          // Filtrer les résultats par d'autres types que 'municipality' ('street')
          const otherFeatures = features.filter(feature => feature.properties.type !== 'municipality')

          // Rassembler les deux groupes filtrés
          const sortedFeatures = municipalityFeatures.concat(otherFeatures)

          this.results = sortedFeatures
        })
        .catch(function(error) {
          console.error('api-adresse', error)
        })
    },
    adresseSelected(adresse) {
      // On agit directement
      this.$store.state.adresse.filter = adresse
      this.go()
    },
    adresseClicked(adresse) {
      // Rien
    },

    go() {
      // Clic sur le bouton de recherche : première adresse si au moins un résultat
      if (!this.$store.state.adresse.filter) {
        if (this.results && this.results.length > 0) {
          this.$store.state.adresse.filter = this.results[0]
        }
      }
      // Une adresse sélectionnée : événement
      if (this.$store.state.adresse.filter) {
        let lon = this.$store.state.adresse.filter.geometry.coordinates[0]
        let lat = this.$store.state.adresse.filter.geometry.coordinates[1]
        this.$emit('lonlat', {
          lon,
          lat
        })
      }
      this.$emit('changeLocalisation')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.v-autocomplete-list {
  width: 100%;
  max-height: 200px;
  overflow-y: scroll;
}

.v-autocomplete-list-item {
  cursor: pointer;
  background-color: #fff;
  color: #000;
  padding: 10px;
  border-bottom: 1px solid #a8a8a8;
}

.home_search_bar input, .map_search_bar input {
  border: none;
}
.search-btn {
  width: 40px;
  height: 40px;
  background-image: url('../assets/img/icon-search.svg');
  background-repeat: no-repeat;
}

.search-btn:hover {
  background-image: url('../assets/img/icon-search-hover.svg');
}

.search_bar {
  transition: -webkit-box-shadow, box-shadow 1000ms cubic-bezier(0.165, 0.84, 0.44, 1);
}

.search_bar.em {
  -webkit-box-shadow: 5px 5px 10px 0px #f7ca9c;
  box-shadow: 5px 5px 10px 0px #f7ca9c;
  transition: -webkit-box-shadow, box-shadow 200ms cubic-bezier(0.165, 0.84, 0.44, 1);
}

.search_bar.em .icon_location {
  /* filter: invert(.5) sepia(1) saturate(3) hue-rotate(340deg); */
  opacity: 0.6;
}

.search_bar.em input::placeholder {
  color: #f6a451;
  opacity: 1;
}

.search_bar.em input:-ms-input-placeholder,
.search_bar.em input::-ms-input-placeholder {
  color: #f6a451;
  opacity: 1;
}

.single_page .search_bar .search-btn {
  background-color: #007abc;
  transition: background-color 1000ms cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: default;
}

.single_page .search_bar.em .search-btn {
  opacity: 0.8;
  background-color: #fcb66f;
  transition: background-color 200ms cubic-bezier(0.165, 0.84, 0.44, 1);
}

.tooltipSearchBar {
  padding: 2px;
  position: absolute;
  right: 25%;
  width:50%;
  text-justify: inter-word;
  background-color: rgba(31, 81, 126, 1);
  border: 1px solid white;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  -ms-border-radius: 2px;
  border-radius: 2px;
  color:white;
  word-spacing: 2px;
  z-index:999;
  display: flex;
}

.introductionExtend {
  color: #fff;
  font-size: 1em;
  margin:0;
}
</style>
